import React from 'react';
import { GoogleMap } from '@react-google-maps/api';
import { mapUIstyles } from './JoyInteractableMap.styles';
import './JoyInteractableMap.css';
import { centerAndZoom } from './JoyInteractableMap.utils';

export const DEFAULT_MAP_SEARCH_RADIUS_MILES = 10;

interface JoyInteractableMapProps {
  id?: string;
  center: { lat: number; lng: number };
  radiusMiles?: number;
  autoCenterAndZoom?: boolean;
  zoom?: number;
  gestureHandling?: 'cooperative' | 'greedy' | 'none';
  onClick?: (e: MouseEvent) => void;
}

export const JoyInteractableMap: React.FC<JoyInteractableMapProps> = ({
  center,
  radiusMiles = DEFAULT_MAP_SEARCH_RADIUS_MILES,
  autoCenterAndZoom,
  zoom = 15,
  gestureHandling = 'cooperative',
  onClick,
  ...props
}) => {
  return (
    <GoogleMap
      mapContainerStyle={{
        width: '100%',
        height: '100%'
      }}
      onLoad={map => {
        if (autoCenterAndZoom) {
          centerAndZoom(center, radiusMiles, map);
        }
      }}
      options={{
        styles: mapUIstyles,
        disableDefaultUI: true,
        gestureHandling
      }}
      clickableIcons={false}
      center={center}
      onClick={e => {
        if (onClick) {
          onClick(e.domEvent as MouseEvent);
        }
      }}
      zoom={zoom}
      {...props}
    />
  );
};
